import React from "react";
import "./OurJourney.css";
// import { gsap } from "gsap";
import { Container, Col, Row, Button, Tab, Tabs, Table } from "react-bootstrap";
import HeroHow from "../../../Images/HeroHow.png";
import EachTestiImg from "./../../../Images/testimonials.png";
import DseImg from "./../../../Images/dse.png";
import NseImg from "./../../../Images/nse.png";
import BseImg from "./../../../Images/bse.png";
import CdslImg from "./../../../Images/cdsl.png";
import NsdlImg from "./../../../Images/nsdl.png";
import mcxNcdexImg from "./../../../Images/mcxNcdex.png";
function OurJourney() {
  return (
    <>
      <section className="our-journey">
        <Container className="add-border">
          <Row>
            <Col md={12}>
              <div className="our-plan-alpha">
                <h2>Our Journey</h2>
                <Tabs
                  defaultActiveKey="one"
                  transition={true}
                  id="ourJourney-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="one" title="1989">
                    <Row>
                      <Col md={6} sm={6}>
                        <img className="img-fluid" src={DseImg} alt="DseImg" />
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>Took the membership of DSE</h5>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="two" title="1995">
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>Became the member of NSE</h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <img className="img-fluid" src={NseImg} alt="NseImg" />
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="three" title="1997">
                    <Row>
                      <Col md={6} sm={6}>
                        <img className="img-fluid" src={BseImg} alt="BseImg" />
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>Became the member of BSE</h5>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="four" title="2000">
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>Depository Participant with NSDL</h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <img
                          className="img-fluid"
                          src={NsdlImg}
                          alt="NsdlImg"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} sm={6}>
                        <img
                          className="img-fluid"
                          src={CdslImg}
                          alt="CdslImg"
                        />
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>Depository Participant with CDSL</h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>Crosses 10000 customers</h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                    </Row>
                  </Tab>
                  {/* <Tab eventKey="seven" title="2000">
                    <Row>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>crosses 10000 customers</h5>
                      </Col>
                    </Row>
                  </Tab> */}
                  {/* <Tab eventKey="five" title="2015">
                    <Row>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>Depository Participant with CDSL</h5>
                      </Col>
                    </Row>
                  </Tab> */}
                  <Tab eventKey="six" title="2003">
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>Started Commodity Brokerage operations in NCDEX and MCX</h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <img
                          src={mcxNcdexImg}
                          alt="mcxNcdexImg"
                          className="img-fluid"
                        />
                      </Col>
                    </Row>
                  </Tab>

                  <Tab eventKey="eight" title="2008">
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>Crossed 10000 Client Mark</h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="nine" title="2009">
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>Started Algo trading at NSE <br></br>co-location</h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="ten" title="2015">
                    <Row>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>Started dedicated FPI desk</h5>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="eleven" title="2016">
                    <Row>
                      <Col md={6} sm={6}>
                        <h5>
                          Act as a Stock broker and clearing member on
                          derivative segment of India International Exchange
                        </h5>
                      </Col>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="twelve" title="2022">
                    <Row>
                      <Col md={6} sm={6}>
                        <div className="box-shadow"></div>
                      </Col>
                      <Col md={6} sm={6}>
                        <h5>Forayed into Discount Broking</h5>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default OurJourney;
